import { render, staticRenderFns } from "./ActivixConfirmModal.vue?vue&type=template&id=330e3e0a&"
import script from "./ActivixConfirmModal.vue?vue&type=script&lang=js&"
export * from "./ActivixConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports